import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { useRef, useEffect, useState, useContext } from 'react';
import ReactDOM from 'react-dom';
import styles from './MobileNonStickyButton.module.scss';
import { Tooltip } from './Tooltip';
import { TooltipContext } from './Context';
import { SmallHeartIcon } from './icons';
export const MobileNonStickyButton = ({ isAlreadyAdded, handleClick, root }) => {
    const buttonRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const { onFollow } = useContext(TooltipContext);
    useEffect(() => {
        if (root) {
            const handleScroll = () => setScrollTop(window.scrollY);
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
    }, [root]);
    const onClick = (e) => {
        e.preventDefault();
        buttonRef.current.blur();
        onFollow(handleClick());
    };
    const wrapper = (_jsxs(_Fragment, { children: [_jsx("button", Object.assign({ className: `wds-button wds-is-text ${styles.button}`, onClick: onClick, ref: buttonRef }, { children: _jsx(SmallHeartIcon, { isFilled: isAlreadyAdded }, void 0) }), void 0), _jsx(Tooltip, { variant: "mobile-non-sticky", isOnScreen: scrollTop < 10 }, void 0)] }, void 0));
    return ReactDOM.createPortal(wrapper, root);
};
